var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatedStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.525 1.25H6.975L7.96541 4.53459L11.25 5.525V5.975L7.96541 6.96541L6.975 10.25H6.525L5.53459 6.96541L2.25 5.975V5.525L5.53459 4.53459L6.525 1.25Z",
    fill: "#141B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 10.4548L16.7346 5.43933L13.5938 8.58006L16.5138 11.5L15.4531 12.5607L12.5332 9.64072L4.43933 17.7346V22.75H9.45476L21.75 10.4548Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedStatus);
export default __webpack_public_path__ + "static/media/created-status.227b1b697172e9f168d69de21990b071.svg";
export { ForwardRef as ReactComponent };